import type {
	ClientResponse,
	ServerResponse,
} from "@onhandtech/onhand-fe-shared/lib/api/v5/request-filter-set/get-request-filter-set";
import {
	handleFailure,
	handleSuccess,
	moduleName,
} from "@onhandtech/onhand-fe-shared/lib/api/v5/request-filter-set/get-request-filter-set";
import type { GetRequestFilterSetParams } from "@onhandtech/onhand-fe-shared/lib/contracts/api/v5/request-filter-set/request-filter-set";
import { createReduxServiceModule } from "@onhandtech/onhand-fe-shared/lib/redux";
import type { RequestArgs } from "@onhandtech/onhand-fe-shared/lib/request";
import { formatEndpoint } from "@onhandtech/onhand-fe-shared/lib/request";
import { getConfig } from "config/configuration";
import { ContentPublishStatus } from "constants/publish-status";

const { endpoints } = getConfig();

const args: RequestArgs<
	ServerResponse,
	ClientResponse,
	GetRequestFilterSetParams,
	never
> = {
	method: "GET",
	url: formatEndpoint(endpoints.api.v5.requestFilterSet),
	handleSuccess,
	handleFailure,
};

const requestFilterSetsModule = () =>
	createReduxServiceModule<
		ServerResponse,
		ClientResponse,
		GetRequestFilterSetParams,
		never,
		never,
		ContentPublishStatus
	>({
		moduleName,
		args,
		segments: [
			ContentPublishStatus.PUBLIC,
			ContentPublishStatus.TARGETED,
			ContentPublishStatus.UNPUBLISHED,
		] as const,
	});

export default requestFilterSetsModule;
